export default function AprovaLiveLock() {
  return (
    <iframe
      src='https://aprovatotal.com.br/aprovalive-upgrade/'
      className='h-[calc(100vh-134px)] w-full lg:h-[calc(100vh-64px)]'
    />
  );
}
